<script lang="ts">
	import { t } from '#lib/i18n/tranlsator.svelte.ts';
	import type { PollSource } from '#src/types/sources.ts';

	interface Props {
		source: PollSource;
	}
	let { source }: Props = $props();
</script>

<div class="section">
	<div class="poll-header">
		{#if source.accepted != null}
			<span class="outcome-badge" class:passed={source.accepted} class:rejected={!source.accepted}>
				{source.accepted ? t('sources.poll.passed') : t('sources.poll.rejected')}
			</span>
		{/if}
		{#if source.date}
			<span class="date">{source.date}</span>
		{/if}
		{#if source.parliament}
			<span class="parliament">{source.parliament}</span>
		{/if}
	</div>

	{#if source.topics?.length}
		<div class="tags">
			{#each source.topics as topic (topic)}
				<span class="tag">{topic}</span>
			{/each}
		</div>
	{/if}

	{#if source.summary}
		<p class="summary">{source.summary}</p>
	{/if}
</div>

<style lang="scss">
	@use '@astlai/common/styles/mixins' as lib;

	.section {
		@include lib.flex-column();
		gap: 0.5rem;

		.poll-header {
			@include lib.flex-row();
			@include lib.flex-align(flex-start, center);
			flex-wrap: wrap;
			gap: 0.5rem;

			.outcome-badge {
				font-size: 0.75rem;
				font-weight: 600;
				padding: 0.125rem 0.75rem;
				border-radius: 999px;

				&.passed {
					background: var(--surface-success);
					color: var(--text-success);
				}
				&.rejected {
					background: var(--surface-error);
					color: var(--text-error);
				}
			}

			.date,
			.parliament {
				font-size: 0.75rem;
				color: var(--text-secondary);
			}
		}

		.tags {
			@include lib.flex-row();
			flex-wrap: wrap;
			gap: 0.25rem;

			.tag {
				font-size: 0.75rem;
				padding: 0.125rem 0.5rem;
				border-radius: 999px;
				background: var(--surface-3);
			}
		}

		.summary {
			font-size: 0.875rem;
			color: var(--text-secondary);
			margin: 0;
			line-height: 1.5;
		}
	}
</style>
